import * as Yup from 'yup';
import React, { useState, useEffect, useMemo } from "react"
import "./header.css"
import { Link, useNavigate, useLocation } from "react-router-dom"
import 'react-toastify/dist/ReactToastify.css';
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Avatar from '@mui/material/Avatar';
import { myProfile } from '../../../api/package';

/**
 * Header Component
 * Navigation menu that changes based on:
 * - Not logged in: Package, Blog, Sign In
 * - Logged in as 'personal': Package, Blog, My Profile section
 * - Logged in as 'corporate': Package, Flight, Hotel, Cab, Bus, Visa, Train, Cruise, Insurance, My Profile section
 */
const Header = () => {
  const location = useLocation();
  const [navList, setNavList] = useState(false)
  const navigate = useNavigate()
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const token = localStorage.getItem('token')
  const [profile, setProfile] = useState('')

  // Get userType from profile or localStorage (default to 'personal')
  const userType = profile?.userType || 'personal';

  const getProfileData = async () => {
    const resp = await myProfile()
    setProfile(resp.data)
    localStorage.setItem('userInfo', JSON.stringify(resp.data))
  }

  useEffect(() => {
    if (token) {
      getProfileData()
    }

  }, [])



  //________________________________________________________________________________________//
  return (
    <>
      <header>
        <div className='container flex position-relative'>
          <div className='logo'>
            <Link to='/tour' className="m-0">
              <img src='/images/logo.jpg' alt='Logo' />
            </Link>
          </div>
          <div className="flex headerMain">
            <div className='nav'>
              <ul className={navList ? "small" : "flex"}>
                {/* Package - visible to all users */}
                <li
                  className={
                    location.pathname === '/tour'
                      ? 'activeMenu'
                      : ''
                  }
                >
                  <Link to='/tour'><i className="fa-solid fa-earth-americas nav-icon-package"></i> <span className="nav-text-package">Package</span></Link>
                </li>

                {/* Corporate-only menu items - only shown when logged in as corporate user */}
                {token && userType === 'corporate' && (
                  <>
                    <li
                      className={
                        location.pathname === '/flight'
                          ? 'activeMenu'
                          : ''
                      }
                    >
                      <Link to='/flight'><i className="fa-solid fa-jet-fighter-up nav-icon-flight"></i> <span className="nav-text-flight">Flight</span></Link>
                    </li>
                    <li
                      className={
                        location.pathname === '/hotels'
                          ? 'activeMenu'
                          : ''
                      }
                    >
                      <Link to='/hotels'><i className="fa-solid fa-building nav-icon-hotel"></i> <span className="nav-text-hotel">Hotel</span></Link>
                    </li>
                    <li
                      className={
                        location.pathname === '/cab'
                          ? 'activeMenu'
                          : ''
                      }
                    >
                      <Link to='/cab'><i className="fa-solid fa-car nav-icon-cab"></i> <span className="nav-text-cab">Cab</span></Link>
                    </li>
                    <li
                      className={
                        location.pathname === '/bus'
                          ? 'activeMenu'
                          : ''
                      }
                    >
                      <Link to='/bus'><i className="fa-solid fa-bus nav-icon-bus"></i> <span className="nav-text-bus">Bus</span></Link>
                    </li>
                    <li
                      className={
                        location.pathname === '/visa'
                          ? 'activeMenu'
                          : ''
                      }
                    >
                      <Link to='/visa'><i className="fa-brands fa-cc-visa fa-fw nav-icon-visa"></i> <span className="nav-text-visa">Visa</span></Link>
                    </li>
                    <li
                      className={
                        location.pathname === '/train'
                          ? 'activeMenu'
                          : ''
                      }
                    >
                      <Link to='/train'><i className="fa-solid fa-train nav-icon-train"></i> <span className="nav-text-train">Train</span></Link>
                    </li>
                    <li
                      className={
                        location.pathname === '/cruise'
                          ? 'activeMenu'
                          : ''
                      }
                    >
                      <Link to='/cruise'><i className="fa-solid fa-ship nav-icon-cruise"></i> <span className="nav-text-cruise">Cruise</span></Link>
                    </li>
                    <li
                      className={
                        location.pathname === '/insurance'
                          ? 'activeMenu'
                          : ''
                      }
                    >
                      <Link to='/insurance'><i className="fa-solid fa-hands-holding-child nav-icon-insurance"></i> <span className="nav-text-insurance">Insurance</span></Link>
                    </li>
                  </>
                )}

                {/* Blog - visible to all (not logged in, personal, but NOT corporate) */}
                {(!token || userType === 'personal') && (
                  <li
                    className={
                      location.pathname === '/blog'
                        ? 'activeMenu'
                        : ''
                    }
                  >
                    <Link to='/blog'><i className="fa-solid fa-blog nav-icon-blog"></i> <span className="nav-text-blog">Blog</span></Link>
                  </li>
                )}

                {/* User Account Section */}
                {token ?
                  <li className='mb-0'>
                    <div className='accountDesktop'>
                      <Button
                        aria-controls={open ? 'basic-menu' : undefined}
                        aria-haspopup="true"
                        aria-expanded={open ? 'true' : undefined}
                        onClick={handleClick}
                      >
                        <Avatar alt={profile?.name} src={profile?.name} />
                      </Button>
                      <Menu
                        id="basic-menu"
                        anchorEl={anchorEl}
                        open={open}
                        onClose={handleClose}
                        MenuListProps={{
                          'aria-labelledby': 'basic-button',
                        }}
                        PaperProps={{
                          className: 'profile-dropdown-menu'
                        }}
                      >
                        <div className="dropdown-header">
                          <div className="dropdown-avatar">
                            <i className="fa-solid fa-user"></i>
                          </div>
                          <div className="dropdown-user-info">
                            <span className="dropdown-user-name">{profile?.name || 'User'}</span>
                            <span className="dropdown-user-email">{profile?.email || ''}</span>
                          </div>
                        </div>
                        <div className="dropdown-divider"></div>
                        <MenuItem className="dropdown-menu-item">
                          <Link className='menuLin' to='/myBooking'>
                            <span className="menu-icon menu-icon-bookings">
                              <i className="fa-solid fa-ticket"></i>
                            </span>
                            My Bookings
                          </Link>
                        </MenuItem>
                        <MenuItem className="dropdown-menu-item">
                          <Link className='menuLin' to='/profile'>
                            <span className="menu-icon menu-icon-profile">
                              <i className="fa-solid fa-user-pen"></i>
                            </span>
                            My Profile
                          </Link>
                        </MenuItem>
                        <MenuItem className="dropdown-menu-item">
                          <Link className='menuLin' to='/changePassword'>
                            <span className="menu-icon menu-icon-password">
                              <i className="fa-solid fa-key"></i>
                            </span>
                            Change Password
                          </Link>
                        </MenuItem>
                        <div className="dropdown-divider"></div>
                        <MenuItem className="dropdown-menu-item logout-item" onClick={handleClose}>
                          <Link
                            className='menuLin'
                            to={'/login'}
                            onClick={() => {
                              localStorage.clear()
                              navigate('/login')
                            }}
                          >
                            <span className="menu-icon menu-icon-logout">
                              <i className="fa-solid fa-right-from-bracket"></i>
                            </span>
                            Log Out
                          </Link>
                        </MenuItem>
                      </Menu>
                    </div>
                    <div className='accountMobile'>
                      <Link className='menuLin' to='/myBooking'><i className="fa-solid fa-money-bill"></i> My Bookings</Link>
                      <Link className='menuLin' to='/profile'><i className="fa-solid fa-user"></i> My Profile</Link>
                      <Link className='menuLin' to='/changePassword'><i className="fa-solid fa-lock"></i> Change Password</Link>
                      <Link className='menuLin' to={'/login'}
                        onClick={() => {
                          localStorage.clear()
                          navigate('/login')
                        }}
                      ><i className="fa-solid fa-right-from-bracket"></i> Log Out</Link>
                    </div>
                  </li>
                  :
                  <li className='btnLogin mb-0'>
                    <Link to='/login'>
                      <i className="fa-solid fa-right-to-bracket"></i> Sign In
                    </Link>
                  </li>
                }
              </ul>
            </div>
            <div className='toggle'>
              <button onClick={() => setNavList(!navList)}>{navList ? <i className='fa fa-times'></i> : <i className='fa fa-bars'></i>}</button>
            </div>
          </div>
        </div>
      </header>
    </>
  )
}

export default Header